import React from 'react';
import GradientText from './reactbits/GradientText/GradientText';
import ShinyText from './reactbits/ShinyText/ShinyText';
import Reveal from './ui/Reveal';

const ServicesBreadcrumbs = () => {
  return (
    <section className="breadcrumbs">
      {/* Breadcrumb text and layout */}
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="breadcrumb-wrapper">
              <Reveal className="breadcrumb-cnt" delay={0.06}>
                <span>
                  <GradientText as="span" className="nalexus-heading-gradient" animationSpeed={12}>
                    Services
                  </GradientText>
                </span>
                <h1>
                  <ShinyText
                    text="Our Capabilities"
                    className="nalexus-heading-shine"
                    color="#f1ede3"
                    shineColor="#ffd369"
                    speed={2.6}
                  />
                </h1>
                <div className="breadcrumb-list">
                  <a href="/">Home</a>
                  <img src="/assets/img/content/breadcrumb-arrow.svg" alt="" /> Services
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesBreadcrumbs;





